import {
  Box,
  Switch,
  Tooltip,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React from 'react';
import { useStyles } from '../OrgUserRoles/styles';

type Props = {
  keyId: any;
  testid: string;
  name: string;
  alias: string;
  description: string;
  isShared: boolean;
  disabled: boolean;
  checked: boolean;
  isInternal: boolean;
  isRestricted?: boolean;
  onToggle(value: string, key: any);
};

const RolesSwitch: React.FC<Props> = ({
  keyId,
  testid,
  name,
  alias,
  description,
  isShared,
  disabled,
  checked,
  isInternal,
  isRestricted,
  onToggle,
}) => {
  const classes = useStyles();
  return (
    <Box
      key={keyId}
      p={1}
      sx={{ display: 'flex' }}
      data-testid={`${testid}-box`}
    >
      <Box>
        <Switch
          size="medium"
          color="primary"
          name={name}
          value={name}
          checked={checked}
          onChange={onToggle(name, keyId)}
          disabled={disabled}
          data-testid={`${testid}-switch`}
        />
      </Box>
      <Box ml={2}>
        <Typography variant="subtitle1" data-testid={`${testid}-alias`}>
          {alias}&nbsp;&nbsp;
          {isShared && (
            <Tooltip
              border="light"
              title={`This role is shared with other services. Selecting / deselecting it here will affect every service that uses this role.`}
              detailed
            >
              <Box component="label" className={classes.sharedRole}>
                SHARED ROLE
              </Box>
            </Tooltip>
          )}
          {isInternal && (
            <Tooltip
              border="light"
              title={`This role is shown to Internal Cambridge staff only and cannot be administered by external customers.`}
              detailed
            >
              <Box
                component="label"
                className={classes.internalRole}
                data-testid={`${testid}-internal-role`}
              >
                INTERNAL ROLE
              </Box>
            </Tooltip>
          )}
          {isRestricted && (
            <Tooltip
              border="light"
              title={`This role can be applied to any user, but can only be seen and administered by Cambridge internal staff.`}
              detailed
            >
              <Box
                component="label"
                className={classes.restrictedRole}
                data-testid={`${testid}-restricted-role`}
              >
                RESTRICTED ROLE
              </Box>
            </Tooltip>
          )}
        </Typography>
        <Typography
          variant="body1"
          style={{ fontSize: '1.15em', lineHeight: '1.51em' }}
          data-testid={`${testid}-description`}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default RolesSwitch;
